import {TokboxRestService} from './restServices/restServices';
import storageService from './storageService';
import VIDABOO_CONSTANTS from '../config/consts';
import mediaDevicesService from './mediaDevicesService';

// let privateState = {}; // private variables for this service.
const service = {};
service.maxHeightWidthRatio = 9 / 16;
service.maxSideBarStreams = 4;
service.streamDotsPaginationCompHeight = 25;
service.videoCtrlIconsCompHeight = 52 + 5; //5 for space at bottom of component, aligned with et-video-control-icons-wrap -> bottom

service.getOTSessionData = async (token) => {
  const requestObject = {
    endpoint: 'sessions',
    token: token ? token : storageService.getItem('token'),
  };
  const tokboxResponse = await TokboxRestService.get(
    requestObject,
    requestObject,
  );
  return tokboxResponse;
};

service.getTokenForSession = async (sessionId, token) => {
  const requestObject = {
    endpoint: 'token',
    endpointParam: sessionId,
    token: token ? token : storageService.getItem('token'),
  };
  const tokboxResponse = await TokboxRestService.get(
    requestObject,
    requestObject,
  );
  return tokboxResponse;
};
service.limitStreamsByRatio = (streamWidth, streamHeight) => {
  // console.debug(streamWidth, streamHeight);
  streamWidth =
    streamWidth > streamHeight &&
    streamHeight <= streamWidth * service.maxHeightWidthRatio
      ? streamHeight / service.maxHeightWidthRatio
      : streamWidth;

  // streamWidth =
  //   streamHeight > streamWidth &&
  //   streamHeight >= streamWidth * service.maxHeightWidthRatio
  //     ? streamHeight / service.minHeightWidthRatio
  //     : streamWidth;
  // console.debug(streamWidth, streamHeight);

  return [streamWidth, streamHeight];
};

service.calculateStreamsLayout = (
  screenWidth,
  screenHeight,
  numOfStreams,
  maxHeightWidthRatio,
) => {
  // numerical algorithm:
  let optimalTileHeight = 0;
  let optimalNumOfRows = numOfStreams;
  let maxNumOfCellsInRow = 1;
  screenHeight = screenHeight - 2 * service.videoCtrlIconsCompHeight;
  for (let numOfRows = 1; numOfRows <= numOfStreams; numOfRows++) {
    let numOfCols = Math.ceil(numOfStreams / numOfRows);
    const isWidthLimiter =
      (maxHeightWidthRatio * screenWidth) / numOfCols <
      screenHeight / numOfRows;
    let tileHeight = screenHeight / numOfRows;
    let tileWidth = tileHeight / maxHeightWidthRatio;
    if (isWidthLimiter) {
      tileWidth = screenWidth / numOfCols;
      tileHeight = tileWidth * maxHeightWidthRatio;
    }
    if (
      tileHeight * numOfRows <= screenHeight &&
      tileWidth * numOfCols <= screenWidth &&
      tileHeight > optimalTileHeight
    ) {
      optimalTileHeight = tileHeight;
      optimalNumOfRows = numOfRows;
      maxNumOfCellsInRow = numOfCols;
    }
  }
  let tileHeight = optimalTileHeight;
  let tileWidth = tileHeight / maxHeightWidthRatio;
  // console.debug(
  //   'numOfCols: ',
  //   maxNumOfCellsInRow,
  //   'numOfRows: ',
  //   optimalNumOfRows,
  //   'tileHeight: ',
  //   tileHeight,
  //   'tileWidth: ',
  //   tileWidth,
  // );
  return {
    numOfRows: optimalNumOfRows,
    maxNumOfCellsInRow: maxNumOfCellsInRow,
    tileWidth: tileWidth,
    tileHeight: tileHeight,
  };
};

service.calcGalleryLayout = (extStreams, fullVideoControllerDimensions) => {
  let numOfGalleryStreams = extStreams.length;
  if (numOfGalleryStreams === 1) {
    const extStream = {...extStreams[0]};
    extStream.width = fullVideoControllerDimensions.width / 1;
    extStream.height = fullVideoControllerDimensions.height / 1;
    extStream.top = fullVideoControllerDimensions.top + 0;
    extStream.left = fullVideoControllerDimensions.left + 0;
    extStream.borderRadius = fullVideoControllerDimensions.borderRadius ?? 0;
    extStream.padding = 0;
    extStream.isVisible = true;
    extStreams[0] = extStream;
  } else {
    // large screen
    const {numOfRows, maxNumOfCellsInRow, tileWidth, tileHeight} =
      service.calculateStreamsLayout(
        fullVideoControllerDimensions.width,
        fullVideoControllerDimensions.height,
        numOfGalleryStreams,
        service.maxHeightWidthRatio,
      );

    const paddingWidth = 0;
    const paddingHeight = 0;
    let streamWidth = tileWidth;
    let streamHeight = tileHeight;
    // let streamWidth = fullVideoControllerDimensions.width / maxNumOfCellsInRow;
    // let streamHeight = fullVideoControllerDimensions.height / (numOfRows + 0.5);

    // [streamWidth, streamHeight] = service.limitStreamsByRatio(
    //   streamWidth,
    //   streamHeight,
    // );

    for (let index = 0; index < extStreams.length; index++) {
      const rowNum = Math.floor(index / maxNumOfCellsInRow);
      const extStream = {...extStreams[index]};
      extStream.borderRadius = 6;
      extStream.padding = fullVideoControllerDimensions.top < 500 ? 3 : 5;
      extStream.isVisible = true;

      extStream.width = streamWidth - paddingWidth * 2;
      extStream.height = streamHeight - paddingHeight * 2;
      extStream.top =
        (fullVideoControllerDimensions.top > 0
          ? fullVideoControllerDimensions.top
          : (fullVideoControllerDimensions.height - streamHeight * numOfRows) /
            2) +
        streamHeight * rowNum +
        paddingHeight;
      const streamsInLastRow = numOfGalleryStreams % maxNumOfCellsInRow;

      if (
        streamsInLastRow === 0 ||
        index < numOfGalleryStreams - streamsInLastRow
      ) {
        extStream.left =
          fullVideoControllerDimensions.left +
          paddingWidth +
          fullVideoControllerDimensions.width / 2 -
          (streamWidth * maxNumOfCellsInRow) / 2 +
          streamWidth * (index % maxNumOfCellsInRow);
        // full rows.
      } else {
        // last row, could not be full.
        extStream.left =
          fullVideoControllerDimensions.left +
          paddingWidth +
          fullVideoControllerDimensions.width / 2 -
          (streamWidth * streamsInLastRow) / 2 +
          streamWidth * (index % maxNumOfCellsInRow);
        // full rows.
      }
      extStreams[index] = extStream;
    }
  }

  return extStreams;
};
service.calcPublisherOnlyLayout = (
  myPublisherExtStream,
  fullVideoControllerDimensions,
  options,
) => {
  const screenToPublisherRatio = options?.isMeetingRoom ? 1 : 2.5;
  let widthGtHeight = false;
  myPublisherExtStream = {...myPublisherExtStream};
  if (
    fullVideoControllerDimensions.width > fullVideoControllerDimensions.height
  ) {
    widthGtHeight = true;
    myPublisherExtStream.height =
      fullVideoControllerDimensions.height / screenToPublisherRatio;
    myPublisherExtStream.width = Math.min(
      fullVideoControllerDimensions.width,
      myPublisherExtStream.height / service.maxHeightWidthRatio,
    );
  } else {
    myPublisherExtStream.width =
      fullVideoControllerDimensions.width /
      (options?.isMeetingRoom ? 1 : screenToPublisherRatio - 1);
    myPublisherExtStream.height =
      service.maxHeightWidthRatio * myPublisherExtStream.width;
  }

  myPublisherExtStream.left =
    fullVideoControllerDimensions.width / 2 - myPublisherExtStream.width / 2;
  myPublisherExtStream.top =
    options?.isMeetingRoom && widthGtHeight
      ? 0
      : 0.3 * fullVideoControllerDimensions.height;

  myPublisherExtStream.borderRadius =
    options?.isMeetingRoom && widthGtHeight ? 0 : 8;
  myPublisherExtStream.padding =
    options?.isMeetingRoom && widthGtHeight ? 0 : 5;
  return myPublisherExtStream;
};
service.calcPublisherSmallLayout = (
  myPublisherExtStream,
  fullVideoControllerDimensions,
) => {
  myPublisherExtStream = {...myPublisherExtStream};
  const screenToPublisherRatio =
    fullVideoControllerDimensions.width > fullVideoControllerDimensions.height
      ? 5
      : 5;
  myPublisherExtStream.width =
    fullVideoControllerDimensions.width / screenToPublisherRatio;
  myPublisherExtStream.height =
    fullVideoControllerDimensions.width > fullVideoControllerDimensions.height
      ? myPublisherExtStream.width * service.maxHeightWidthRatio
      : myPublisherExtStream.width;
  // [
  //   myPublisherExtStream.width,
  //   myPublisherExtStream.height,
  // ] = service.limitStreamsByRatio(
  //   myPublisherExtStream.width,
  //   myPublisherExtStream.height,
  // );
  myPublisherExtStream.top =
    fullVideoControllerDimensions.height -
    myPublisherExtStream.height -
    fullVideoControllerDimensions.height * 0.09;

  myPublisherExtStream.left =
    fullVideoControllerDimensions.width -
    myPublisherExtStream.width -
    fullVideoControllerDimensions.width * 0.05;

  myPublisherExtStream.borderRadius = 6;
  myPublisherExtStream.padding = 5;
  myPublisherExtStream.isVisible = true;

  return myPublisherExtStream;
};
service.calcEnlargedStreamLayout = (
  enlargedStream,
  fullVideoControllerDimensions,
) => {
  enlargedStream = {...enlargedStream};

  if (
    fullVideoControllerDimensions.width >= fullVideoControllerDimensions.height
  ) {
    const enlargedToScreenRatio = 0.8;
    enlargedStream.width =
      fullVideoControllerDimensions.width * enlargedToScreenRatio;
    enlargedStream.height =
      fullVideoControllerDimensions.height * enlargedToScreenRatio;
    [enlargedStream.width, enlargedStream.height] = service.limitStreamsByRatio(
      enlargedStream.width,
      enlargedStream.height,
    );

    enlargedStream.top =
      (fullVideoControllerDimensions.height * (1 - enlargedToScreenRatio)) / 2;
    enlargedStream.left =
      (fullVideoControllerDimensions.width * enlargedToScreenRatio) / 2 -
      enlargedStream.width / 2;
  } else {
    enlargedStream.width = fullVideoControllerDimensions.width;
    enlargedStream.height = fullVideoControllerDimensions.height * 0.6;
    enlargedStream.top = 0;
    enlargedStream.left = 0;
  }
  enlargedStream.borderRadius = 6;
  enlargedStream.padding = 5;

  return enlargedStream;
};
service.calcSidebarStreams = (
  extStreams,
  enlargedStream,
  fullVideoControllerDimensions,
  layoutOptions,
) => {
  const numOfSidebarStreams = extStreams.length;
  const areStreamsDotVisible = layoutOptions?.selectedStreamDotIdx >= 0;

  if (
    fullVideoControllerDimensions.width >= fullVideoControllerDimensions.height
  ) {
    for (let index = 0; index < numOfSidebarStreams; index++) {
      const extStream = extStreams[index];
      const isStreamVisible = areStreamsDotVisible
        ? index >=
            layoutOptions.selectedStreamDotIdx * service.maxSideBarStreams &&
          index <=
            layoutOptions.selectedStreamDotIdx * service.maxSideBarStreams +
              (service.maxSideBarStreams - 1)
        : true;
      extStream.width =
        fullVideoControllerDimensions.width - enlargedStream.width;
      extStream.height =
        fullVideoControllerDimensions.height - enlargedStream.height;
      [extStream.width, extStream.height] = service.limitStreamsByRatio(
        extStream.width,
        extStream.height,
      );
      extStream.top =
        fullVideoControllerDimensions.height / 2 -
        (areStreamsDotVisible
          ? service.maxSideBarStreams * extStream.height
          : numOfSidebarStreams * extStream.height) /
          2 +
        (areStreamsDotVisible ? index % 4 : index) * extStream.height;
      extStream.left =
        fullVideoControllerDimensions.width -
        (fullVideoControllerDimensions.width -
          enlargedStream.width -
          extStream.width) /
          2 -
        extStream.width;
      extStream.borderRadius = 6;
      extStream.padding = 5;
      extStream.isVisible = isStreamVisible;
    }
  } else {
    // const sidebarDimensions = {};
    // const padding = 5;
    // sidebarDimensions.top = enlargedStream.height;
    // sidebarDimensions.left = padding;
    // sidebarDimensions.height =
    //   fullVideoControllerDimensions.height - enlargedStream.height;
    // sidebarDimensions.width = fullVideoControllerDimensions.width - 2 * padding;
    // sidebarDimensions.borderRadius = 6;

    // extStreams = service.calcGalleryLayout(extStreams, sidebarDimensions);

    fullVideoControllerDimensions.height =
      fullVideoControllerDimensions.height - service.videoCtrlIconsCompHeight;
    for (let index = 0; index < numOfSidebarStreams; index++) {
      const extStream = extStreams[index];
      const isStreamVisible = areStreamsDotVisible
        ? index >=
            layoutOptions.selectedStreamDotIdx * service.maxSideBarStreams &&
          index <=
            layoutOptions.selectedStreamDotIdx * service.maxSideBarStreams +
              (service.maxSideBarStreams - 1)
        : true;
      extStream.borderRadius = 6;
      extStream.padding = 5;
      extStream.isVisible = isStreamVisible;
      extStream.width = fullVideoControllerDimensions.width / 2;
      extStream.height =
        (fullVideoControllerDimensions.height - enlargedStream.height) / 2 -
        (areStreamsDotVisible
          ? service.streamDotsPaginationCompHeight - 2 * extStream.padding
          : 0);
      [extStream.width, extStream.height] = service.limitStreamsByRatio(
        extStream.width,
        extStream.height,
      );
      extStream.top =
        index % 4 === 0 || index % 4 === 1
          ? enlargedStream.height +
            (areStreamsDotVisible ? service.streamDotsPaginationCompHeight : 0)
          : enlargedStream.height +
            (areStreamsDotVisible
              ? service.streamDotsPaginationCompHeight
              : 0) +
            extStream.height;
      extStream.left =
        (index % 2) * extStream.width +
        (fullVideoControllerDimensions.width - 2 * extStream.width) / 2;
    }
  }

  return extStreams;
};
service.calcEnlargedLayout = (
  extStreams,
  fullVideoControllerDimensions,
  layoutOptions,
) => {
  // find the first enlarged screen and place it on the left.
  // all the rest put on the side-bar (or bottom-bar)
  const enlargedStreamIndex = extStreams.findIndex(
    (extStream) => extStream.enlargedView,
  );
  let enlargedStream = extStreams.splice(enlargedStreamIndex, 1)[0];
  enlargedStream = service.calcEnlargedStreamLayout(
    enlargedStream,
    fullVideoControllerDimensions,
  );
  enlargedStream.isVisible = true;
  extStreams = service.calcSidebarStreams(
    extStreams,
    enlargedStream,
    fullVideoControllerDimensions,
    layoutOptions,
  );
  extStreams.splice(enlargedStreamIndex, 0, enlargedStream);

  return extStreams;
};
service.calcVideoLayout = (
  layoutOptions,
  extStreams,
  myPublisherExtStream,
  myScreenshareExtStream,
  fullVideoControllerDimensions,
) => {
  // return {extStreams, myPublisherExtStream, myScreenshareExtStream}; //could happen when closing and unmounting.
  if (!extStreams && !myPublisherExtStream)
    return {extStreams, myPublisherExtStream, myScreenshareExtStream}; //
  let enlargedStreamsLayout = false;
  if (
    myPublisherExtStream?.enlargedView ||
    myScreenshareExtStream?.enlargedView ||
    (extStreams.length > 0 &&
      extStreams.some((extStream) => extStream.enlargedView))
  ) {
    enlargedStreamsLayout = true;
  }
  if (
    myPublisherExtStream &&
    !myScreenshareExtStream &&
    extStreams.length < 1
  ) {
    // only showing myself, not receiving from peer nor sharing screen.
    myPublisherExtStream.isVisible = true;
    myPublisherExtStream = service.calcPublisherOnlyLayout(
      myPublisherExtStream,
      fullVideoControllerDimensions,
      layoutOptions,
    );
    return {extStreams, myPublisherExtStream, myScreenshareExtStream};
  } else if (enlargedStreamsLayout) {
    if (
      extStreams.length === 1 &&
      myPublisherExtStream &&
      !myScreenshareExtStream &&
      !myPublisherExtStream.enlargedView
    ) {
      //one-on-one

      // selfSmall mode, only when one-on-one or !selfPublisherInGallery
      myPublisherExtStream = service.calcPublisherSmallLayout(
        myPublisherExtStream,
        fullVideoControllerDimensions,
      );

      extStreams = service.calcGalleryLayout(
        extStreams,
        fullVideoControllerDimensions,
      );
    } else {
      if (myScreenshareExtStream) {
        extStreams.push({...myScreenshareExtStream}); // insert publisher's screenshare stream temporarily into the streams
      }
      if (myPublisherExtStream) {
        extStreams.push({...myPublisherExtStream}); // if self part of gallery or more than one-on-one, insers publisher's position temporarily into the streams
      }
      extStreams = service.calcEnlargedLayout(
        extStreams,
        fullVideoControllerDimensions,
        layoutOptions,
      );

      if (myPublisherExtStream) {
        myPublisherExtStream = extStreams.pop();
      }
      if (myScreenshareExtStream) {
        myScreenshareExtStream = extStreams.pop(); // if self part of gallery, insers publisher's position temporarily into the streams
      }
    }
  } else {
    // Gallery mode. In case

    if (myScreenshareExtStream) {
      extStreams.push({...myScreenshareExtStream}); // insert publisher's screenshare stream temporarily into the streams
    }
    if (myPublisherExtStream) {
      extStreams.push({...myPublisherExtStream}); //  insers publisher's position temporarily into the streams
    }
    extStreams = service.calcGalleryLayout(
      extStreams,
      fullVideoControllerDimensions,
    );

    if (myPublisherExtStream) {
      myPublisherExtStream = extStreams.pop();
    }
    if (myScreenshareExtStream) {
      myScreenshareExtStream = extStreams.pop(); // if self part of gallery, insers publisher's position temporarily into the streams
    }
  }

  return {extStreams, myPublisherExtStream, myScreenshareExtStream};
};

service.getDefaultMediaDevices = async () => {
  // returns the saved default device. In case it hasn't been saved or it's been removed from the device list, will return the first one from the list or null if list is empty
  try {
    const defaultMediaDevicesStr = storageService.getItem(
      'defaultMediaDevices',
    );
    let defaultMediaDevices = JSON.parse(defaultMediaDevicesStr || '{}');

    const devices = await mediaDevicesService
      .getMediaDevices()
      .enumerateDevices();
    let defaultVideoInputDevice =
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.VIDEO_INPUT &&
          device.deviceId ===
            defaultMediaDevices.defaultVideoInputDevice?.deviceId,
      ) ??
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.VIDEO_INPUT &&
          device.deviceId === 'default',
      ) ??
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.VIDEO_INPUT,
      );

    const defaultAudioInputDevice =
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_INPUT &&
          device.deviceId ===
            defaultMediaDevices.defaultAudioInputDevice?.deviceId,
      ) ??
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_INPUT &&
          device.deviceId === 'default',
      ) ??
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_INPUT,
      );

    const defaultAudioOutputDevice =
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_OUTPUT &&
          device.deviceId ===
            defaultMediaDevices.defaultAudioOutputDevice?.deviceId,
      ) ??
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_OUTPUT &&
          device.deviceId === 'default',
      ) ??
      devices.find(
        (device) =>
          device.kind === VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_OUTPUT,
      );
    return {
      defaultVideoInputDevice,
      defaultAudioInputDevice,
      defaultAudioOutputDevice,
    };
  } catch (err) {
    console.debug(err);
    return null;
  }
};
service.setDefaultMediaDevice = async (deviceType, deviceId) => {
  const devices = await mediaDevicesService
    .getMediaDevices()
    .enumerateDevices();

  const newDefaultDevice = devices.find(
    (device) => device.deviceId === deviceId && device.kind === deviceType,
  );
  if (!newDefaultDevice) return false;

  const defaultMediaDevicesStr = storageService.getItem('defaultMediaDevices');
  let defaultMediaDevices = JSON.parse(defaultMediaDevicesStr || '{}');

  switch (deviceType) {
    case VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.VIDEO_INPUT:
      defaultMediaDevices.defaultVideoInputDevice = newDefaultDevice;
      break;
    case VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_INPUT:
      defaultMediaDevices.defaultAudioInputDevice = newDefaultDevice;
      break;
    case VIDABOO_CONSTANTS.MEDIA_DEVICE_TYPES.AUDIO_OUTPUT:
      defaultMediaDevices.defaultAudioOutputDevice = newDefaultDevice;
      break;

    default:
      break;
  }
  storageService.setItem(
    'defaultMediaDevices',
    JSON.stringify(defaultMediaDevices),
  );
  return newDefaultDevice;
};

service.getStreamDotsCount = (streamsCount = 0) => {
  return Math.ceil((streamsCount - 1) / 4); // 1 is subtracted for enlarged stream
};

service.calcDotsPaginationWrap = (
  extStreams,
  myPublisherExtStream,
  myScreenshareExtStream,
  fullVideoControllerDimensions,
) => {
  const isLandscape =
    fullVideoControllerDimensions.width >= fullVideoControllerDimensions.height;
  const enlargedStream =
    myPublisherExtStream && myPublisherExtStream.enlargedView
      ? myPublisherExtStream
      : myScreenshareExtStream && myScreenshareExtStream.enlargedView
        ? myScreenshareExtStream
        : extStreams?.length > 0 &&
          extStreams.find((stream) => stream.enlargedView);
  const smallStream =
    extStreams.length > 0 && extStreams.find((stream) => !stream.enlargedView);

  const streamDotsWrapTopOffset = enlargedStream
    ? isLandscape
      ? enlargedStream.top + enlargedStream.height + 2 * enlargedStream.padding
      : enlargedStream.height
    : '10px';
  const streamDotsWrapLeftOffset = smallStream
    ? isLandscape
      ? smallStream.left + smallStream.padding
      : smallStream.left + smallStream.padding
    : '0px';
  const streamDotsWrapWidth = smallStream
    ? isLandscape
      ? smallStream.width - 2 * smallStream.padding
      : 2 * smallStream.width - 2 * smallStream.padding
    : '100%';

  return {
    streamDotsWrapTopOffset,
    streamDotsWrapLeftOffset,
    streamDotsWrapWidth,
  };
};

export default service;
